import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import AboutTile from '../components/AboutTile';
import aboutData from '../data/about.json';

const About = () => {
    return (
        <>
            <SEO page="about" />
            <AboutTile
                title={aboutData.title}
                paragraphs={aboutData.paragraphs}
                stats={aboutData.stats}
            />
            
            {/* Why Choose Us Section */}
            <div className="container mx-auto px-4 pb-20">
                <div className="glass-panel p-10 mx-auto animate-fade-in opacity-0">
                    <h2 className="text-2xl font-bold mb-6 text-center text-text-dark">Why Calgary Trusts Magic Man</h2>
                    <div className="grid md:grid-cols-2 gap-10 max-w-5xl mx-auto">
                        <div className="flex items-center gap-5 text-left">
                            <span className="text-4xl flex-shrink-0">🔧</span>
                            <div>
                                <h3 className="text-xl font-bold text-text-dark">Double Red Seal Certified</h3>
                                <p className="text-lg text-text-light">Expert-level qualifications in plumbing and gasfitting</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-5 text-left">
                            <span className="text-4xl flex-shrink-0">⏰</span>
                            <div>
                                <h3 className="text-xl font-bold text-text-dark">24/7 Emergency Service</h3>
                                <p className="text-lg text-text-light">Available around the clock for urgent issues</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-5 text-left">
                            <span className="text-4xl flex-shrink-0">🏠</span>
                            <div>
                                <h3 className="text-xl font-bold text-text-dark">Commercial & Residential</h3>
                                <p className="text-lg text-text-light">Experience with all property types</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-5 text-left">
                            <span className="text-4xl flex-shrink-0">✅</span>
                            <div>
                                <h3 className="text-xl font-bold text-text-dark">Premium Quality Products</h3>
                                <p className="text-lg text-text-light">We only use high-quality materials that last</p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-8 text-center">
                        <Link to="/contact">
                            <button className="glass-button px-8 py-4">
                                Get in Touch
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default About;
